import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BotonVolver from './BotonVolver';
import BotonWhatsApp from './BotonWhatsApp';


export default function Financiera() {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation("global");

  const handleContact = () => {
    navigate('/'); // Navega a la ruta principal
    setTimeout(() => {
      const contactElement = document.getElementById('contacto');
      if (contactElement) {
        contactElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500); 
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-black to-zinc-900">
      {/* Back Button */}
      <BotonVolver text={t("financiera.volver")} />

      <main className="container mx-auto px-4 pt-16">
        {/* Hero Section */}
        <section className="pt-16 pb-16 text-center">
          <h1 className="text-5xl md:text-6xl font-messina tracking-wide text-white mb-4">
          {t("financiera.title")}
          </h1>
          <p className="text-xl text-gray-300 font-neolatina mb-8 max-w-3xl mx-auto">
          {t("financiera.texto-1")}
          </p>
          <BotonWhatsApp 
            text={t("financiera.texto-2")} 
            message="¡Hola! Me interesa obtener más información sobre el Sistema de Gestión Financiera." 
          />
        </section>

        {/* Features Section */}
        <section className="py-16">
          <div className="bg-zinc-800/70 backdrop-blur rounded-lg p-8 shadow-lg">
            <h2 className="text-4xl font-messina tracking-wide text-white mb-8 text-center">
            {t("financiera.texto-3")}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
              {
                title: t("financiera.title-1"),
                description: t("financiera.descripcion-1")
              },
              {
                title: t("financiera.title-2"),
                description: t("financiera.descripcion-2")
              },
              {
                title: t("financiera.title-3"),
                description: t("financiera.descripcion-3")
              },
              {
                title: t("financiera.title-4"),
                description:t("financiera.descripcion-4")
              },
              {
                title: t("financiera.title-5"),
                description: t("financiera.descripcion-5")
              },
              {
                title: t("financiera.title-6"),
                description: t("financiera.descripcion-6")
              }
              ].map((feature, index) => (
                <div key={index} className="bg-zinc-900/50 p-6 rounded-lg space-y-3 hover:bg-zinc-700/50 transition-colors">
                  <h3 className="text-2xl font-semibold text-white">{feature.title}</h3>
                  <p className="text-gray-300">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="flex flex-col justify-center items-center bg-zinc-900/50 backdrop-blur rounded-lg p-8">
            <div className="text-5xl font-bold text-white mb-2">50000+</div>
            <div className="text-gray-400">{t("financiera.texto-4")}</div>
          </div>
          <div className="flex flex-col justify-center items-center  bg-zinc-900/50 backdrop-blur rounded-lg p-8">
            <div className="text-5xl font-bold text-white mb-2">20+</div>
            <div className="text-gray-400">{t("financiera.texto-5")}</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 text-center">
          <div className="bg-zinc-900/50 backdrop-blur rounded-lg p-8">
            <h2 className="text-3xl font-messina tracking-wide text-white mb-4">
            {t("financiera.texto-6")}
            </h2>
            <p className="text-xl font-neolatina text-gray-300 mb-8">
            {t("financiera.texto-7")}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                className="px-6 py-3 text-lg bg-white text-black hover:bg-gray-200 rounded-lg transition-colors"
                onClick={handleContact}
              >
                {t("financiera.texto-8")}
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
